<template>  
  <div>
    <q-card inline style="width: 300px"> 
       <q-card-main>
        <q-toolbar color="primary">
        <q-toolbar-title>
          {{$t('global.ManageProducts')}}
        </q-toolbar-title>
        </q-toolbar>
        <hr>
        <div class="row"> 
          <div class="col-12">
            <q-btn class="space float-right" color="primary" :label="$t('global.NewProductGroup')" size="sm" @click="addGroup = true" />
          </div>
          <div class="col-12">
          <q-table
            :title="$t('global.ProductGroup')"
            :data="groupRows"
            :columns="columnsEvent"
            row-key="value"
            :dense=true
            selection="single" 
            :selected.sync="selectedGroupRows"
            :pagination.sync="pagination" 
          >  
          <template slot="top-selection" slot-scope="props" >
            <div class="q-table-title">{{$t('global.ProductGroup')}}</div>
            <div>
              <q-btn color="secondary" flat :label="$t('global.Edit')" @click="editGroup()" />  
              <q-btn color="secondary" flat :label="$t('global.Delete')" @click="deleteGroup()" v-if="selectedGroupRows[0].CanDelete == true" />
            </div>
          </template>
            </q-table>
          </div>
        </div>
       </q-card-main>
    </q-card>
    <q-card inline style="width: 300px">
      <q-card-main>
        <div> 
          <div class="row">
            <div class="col-12">
            <q-btn v-if="selectedGroupRows.length > 0" class="space float-right" color="primary" :label="newTitle" size="sm" @click="addDialog = true" />
            </div>
            <div class="col-12" v-if="selectedGroupRows.length != 0">
              <q-table
                :title="title"
                :data="dataRows"
                :columns="columnsEvent"
                row-key="value"
                :dense=true
                selection="single"
                :selected.sync="selectedDataRows"
                :pagination.sync="pagination" 
                >
                <q-td slot="body-cell-Thumbnail" slot-scope="props" :props="props">
                  <img :src="'data:image/png;base64,' + props.value" @click="showPic(props.row.IdEvent)">
                </q-td>
              <template slot="top-selection" slot-scope="props" >
                <div class="q-table-title">{{title}}</div>
                <div>
                  <q-btn color="secondary" flat :label="$t('global.Edit')" @click="editProduct()" />  
                  <q-btn color="secondary" flat :label="$t('global.Delete')" @click="deleteEntity()" v-if="selectedDataRows[0].CanDelete == true" />
                </div>
              </template>
              </q-table>
            </div>
          </div>  
          <br>
        </div>
            
        <q-dialog
          v-model="editDialog"
          prevent-close  
        > 
        <span slot="title">{{title}}</span>
        <div slot="body">
            <q-input v-model="editName" ref="editName" float-label="Name"/>
        </div>
        <template slot="buttons" slot-scope="props">
          <q-btn color="primary" :label="$t('global.Save')" @click="updateDelay()" />
          <q-btn flat :label="$t('global.Cancel')" @click="props.cancel" />
        </template>
      </q-dialog>
      <q-dialog
          v-model="editGroupDialog"
          prevent-close  
        > 
        <span slot="title">{{$t('global.ProductGroup')}}</span>
        <div slot="body">
            <q-input v-model="editName" ref="editName" float-label="Name"/>
        </div>
        <template slot="buttons" slot-scope="props">
          <q-btn color="primary" :label="$t('global.Save')" @click="updateGroup()" />
          <q-btn flat :label="$t('global.Cancel')" @click="props.cancel" />
        </template>
      </q-dialog>
      <q-dialog
        class="dia"
        v-model="addDialog"
        prevent-close
        >
        <span slot="title">{{newTitle}}</span>
        <div slot="body">
            <q-input v-model="newEntity" float-label="Name"/>
        </div>
        <template slot="buttons" slot-scope="props">
          <div class="row">
            <div class="col-6">
              <q-btn color="primary" :label="$t('global.Save')" @click="insertProduct()" :disable="newEntity == '' "/>
            </div>
            <div class="col-6">
              <q-btn flat :label="$t('global.Cancel')" @click="props.cancel" />
            </div>
          </div>
        </template>
      </q-dialog>
      <q-dialog
        class="dia"
        v-model="addGroup"
        prevent-close
        >
        <span slot="title">{{$t('global.NewProductGroup')}}</span>
        <div slot="body">
            <q-input v-model="newEntity" float-label="Name"/>
        </div>
        <template slot="buttons" slot-scope="props">
          <div class="row">
            <div class="col-6">
              <q-btn color="primary" :label="$t('global.Save')" @click="saveGroup()" :disable="newEntity == '' "/>
            </div>
            <div class="col-6">
              <q-btn flat :label="$t('global.Cancel')" @click="props.cancel" />
            </div>
          </div>
        </template>
      </q-dialog>
      </q-card-main>
    </q-card>   
  </div>
</template>
<script>
import { date } from 'quasar'
import {eventBus} from '../main'
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'ExportTrack',
  data () {
    return {
      form: {
        SessionId: null,
      },
      IdCostType: '2',
      newEntity: '',
      dataRows: [],
      groupRows:[],
      maintenanceGroupSelected: null,
      title: 'General Editor',
      newTitle: 'General New',
      newOpend: false,
      selectedDataRows: [],
      selectedGroupRows: [],
      columnsEvent: [
        {
          name: 'product',required: true, align: 'left',
          field: 'label',sortable: true
        }],
       pagination: {
        sortBy: null, // String, column "name" property value
        descending: false,
        page: 1,
        rowsPerPage: 10 // current rows per page being displayed
      },
      editDialog: false,
      editGroupDialog: false,
      addDialog: false,
      addGroup: false,
      editName: '',
      Number1: null,
      Number2: null,
      Number3: '',  
    }
  },
  props: ['Entity'],
  methods: {
    loadData(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getEntity"
      this.form.Entity = 'Product'
      this.form.IdProductGroup = this.selectedGroupRows[0].value
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.dataRows = response.data
          }
          else{
              this.$q.notify(this.$t('global.SomethingWrong'))
          }
      })
      .catch(e => {
        this.$q.notify(this.$t('global.SomethingWrong'))
        console.log(e);
      })
    },

    loadGroup(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "getEntity"
      this.form.Entity = 'ProductGroup'
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              this.groupRows = response.data
          }
          else{
              this.$q.notify(this.$t('global.SomethingWrong'))
          }
      })
      .catch(e => {
        this.$q.notify(this.$t('global.SomethingWrong'))
        console.log(e);
      })
    },
    
    Init(){ 
      this.dataRows = []
      this.groupRows = []
      this.title = this.$t('global.Product')
      this.newTitle = this.$t('global.NewProduct')
      this.loadGroup()
    },

    editProduct(){
      this.editName  = this.selectedDataRows[0].label
      
      this.editDialog = true
    },

    editGroup(){
      this.editName  = this.selectedGroupRows[0].label
      this.editGroupDialog = true
    },
    updateDelay(){
      setTimeout(()=>{ this.updateEvent() }, 200)
    },
    updateEvent(){
      this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "updateEntity"
        this.form.Entity = this.Entity.entity
        this.form.Id = this.selectedDataRows[0].value
        this.form.Description = this.editName
        if(this.Entity.entity == 'ResourceTemplate'){
          this.form.Number1 = this.Number1
          this.form.Number2 = this.Number2
          this.form.Number3 = this.Number3
          this.form.IdCostType = this.IdCostType
        }
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.WorkChanged'), type: 'positive' })
                this.selectedDataRows = []
                this.loadData()
                this.editDialog = false
                eventBus.$emit('dataChange', null)
              }
              else{
                this.$q.notify(this.$t('global.SomethingWrong'))
              }
            }
            else{
                this.$q.notify(this.$t('global.SomethingWrong'))
            }
        })
        .catch(e => {
          this.$q.notify(this.$t('global.SomethingWrong'))
          console.log(e);
        })
    },
    updateGroup(){
      this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "updateEntity"
        this.form.Entity = 'ProductGroup'
        this.form.Id = this.selectedGroupRows[0].value
        this.form.Description = this.editName
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.WorkChanged'), type: 'positive' })
                this.selectedDataRows = []
                this.selectedGroupRows = []
                this.loadGroup()
                this.editGroupDialog = false
                eventBus.$emit('dataChange', null)
              }
              else{
                this.$q.notify(this.$t('global.SomethingWrong'))
              }
            }
            else{
                this.$q.notify(this.$t('global.SomethingWrong'))
            }
        })
        .catch(e => {
          this.$q.notify(this.$t('global.SomethingWrong'))
          console.log(e);
        })
    },



    deleteEntity(){
      var self = this
      this.$q.dialog({
        title: this.selectedDataRows[0].label,
        message: this.title + ' ' + this.$t('global.Delete') + '?',
        color: 'primary',
        ok: true, 
        cancel: true, 
        preventClose: true,
        noBackdropDismiss: false, 
        noEscDismiss: false, 
        stackButtons: false,
        position: 'top',     
      })
      .then(() => {
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "deleteEntity"
        this.form.Entity = this.Entity.entity
        this.form.Id = this.selectedDataRows[0].value
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.EntryDeleted'), type: 'positive' })
                this.loadGroup()
                this.loadData()
                this.selectedDataRows = []
                eventBus.$emit('dataChange', null)
              }
              else{
                this.$q.notify(this.$t('global.SomethingWrong'))
              }
            }
            else{
                this.$q.notify(this.$t('global.SomethingWrong'))
            }
        })
        .catch(e => {
          this.$q.notify(this.$t('global.SomethingWrong'))
          console.log(e);
        })
      })
      .catch(() => {
        //alert('Picked cancel')
      })
    },
    deleteGroup(){
      var self = this
      this.$q.dialog({
        title: this.selectedGroupRows[0].label,
        message: this.$t('global.ProductGroup') + ' ' + this.$t('global.Delete') + '?',
        color: 'primary',
        ok: true, 
        cancel: true, 
        preventClose: true,
        noBackdropDismiss: false, 
        noEscDismiss: false, 
        stackButtons: false,
        position: 'top',     
      })
      .then(() => {
        this.form.SessionId = this.$store.state.session.SessionId
        this.form.action = "deleteEntity"
        this.form.Entity = 'ProductGroup'
        this.form.Id = this.selectedGroupRows[0].value
        axios.post(this.$apiUrl,
        qs.stringify(this.form),
        {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
            this.submitting = false
            if(response.status == 200){ 
              if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.EntryDeleted'), type: 'positive' })
                this.loadGroup()
                this.selectedDataRows = []
                this.selectedGroupRows = []
                eventBus.$emit('dataChange', null)
              }
              else{
                this.$q.notify(this.$t('global.SomethingWrong'))
              }
            }
            else{
                this.$q.notify(this.$t('global.SomethingWrong'))
            }
        })
        .catch(e => {
          this.$q.notify(this.$t('global.SomethingWrong'))
          console.log(e);
        })
      })
      .catch(() => {
        //alert('Picked cancel')
      })
    },
    insertProduct(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "insertEntity"
      this.form.Entity = 'Product'
      this.form.IdProductGroup = this.selectedGroupRows[0].value
      this.form.Description = this.newEntity
      

      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.NewEntry'), type: 'positive' })
                this.addDialog = false
                this.newEntity = ''
                //this.selectedGroupRows = []
                this.loadGroup()
                this.loadData()
                eventBus.$emit('dataChange', null)
              }
              else{
                  this.$q.notify(this.$t('global.SomethingWrong'))
              }
          }
          else{
              this.$q.notify(this.$t('global.SomethingWrong'))
          }
      })
      .catch(e => {
        this.$q.notify(this.$t('global.SomethingWrong'))
        console.log(e);
      })
    },
    saveGroup(){
      this.form.SessionId = this.$store.state.session.SessionId
      this.form.action = "insertEntity"
      this.form.Entity = 'ProductGroup'
      this.form.Description = this.newEntity
      axios.post(this.$apiUrl,
      qs.stringify(this.form),
      {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      })
      .then(response => {
          this.submitting = false
          if(response.status == 200){ 
              if(response.data == "OK"){
                this.$q.notify({ message: this.$t('global.NewEntry'), type: 'positive' })
                this.addGroup = false
                this.newEntity = ''
                this.loadGroup()
                eventBus.$emit('dataChange', null)
              }
              else{
                  this.$q.notify(this.$t('global.SomethingWrong'))
              }
          }
          else{
              this.$q.notify(this.$t('global.SomethingWrong'))
          }
      })
      .catch(e => {
        this.$q.notify(this.$t('global.SomethingWrong'))
        console.log(e);
      })
    },
  },
  created () {
    this.Init()
    eventBus.$on('Bus_ChangeLocale', (data) => {
      this.Init()
    })
  },
   watch: {
    Entity: function (newValue, oldValue) { 
      this.Init()
    },
    selectedGroupRows: function (newValue, oldValue) { 
      if(newValue.length != 0){
        this.loadData()
      }
      else{
        this.dataRows = []
      }
    },
   },
  
}

function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}

</script>

<style scoped>
 .space{
    margin-bottom: 10px;
  } 
  
</style>